import { RouteObject } from "react-router-dom";
import RefereeManage from "./RefereeManage";
import AuthGuardWrapper from "../../auth/AuthGuardWrapper";
import {ManageFootballReferee} from "../../../commons/models/football/admin/manage-football-referee";

export const routerAdminReferee: RouteObject[] = [
  {
    path: "",
    element: <AuthGuardWrapper subject={ManageFootballReferee}> <RefereeManage /></AuthGuardWrapper>,
  },
];
